export default function () {
  return {
    errors: {},
    success: false,
    error: false,
    category: {
      name: ''
    }
  }
}
